module.exports = __webpack_public_path__ + "static/media/featured-bg-shape.116c7523.svg";